"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenUrls = exports.TOO_MANY_FILES = exports.NOT_A_FILE = exports.EXT_NOT_ALLOWED = exports.MAX_FILE = exports.supportedProducts = exports.ACCOUNTS_ALLOWED = exports.SIZES = exports.FILE_EXT_MAPPING = exports.MAX_THUMBNAIL_WIDTH = exports.EXT_ALLOWED = exports.MAX_AMOUNT_OF_FILES_UPLOADED_AT_ONCE = exports.MAX_FILE_SIZE = exports.FETCH_AUTHORS_ENDPOINT = exports.FETCH_IMAGES_ENDPOINT = exports.UPLOAD_FILES_ENDPOINT = void 0;

var _storeServiceUrlHelper = _interopRequireDefault(require("../helpers/store-service-url-helper"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var UPLOAD_FILES_ENDPOINT = _storeServiceUrlHelper["default"].getUrl('upload');

exports.UPLOAD_FILES_ENDPOINT = UPLOAD_FILES_ENDPOINT;
var FETCH_IMAGES_ENDPOINT = 'https://api.unsplash.com/search/photos';
exports.FETCH_IMAGES_ENDPOINT = FETCH_IMAGES_ENDPOINT;
var FETCH_AUTHORS_ENDPOINT = 'https://api.unsplash.com/users'; // https://api.unsplash.com/users/sadswim/photos?client_id=98823feb68c3cd3b6c9495406a9d76630c3ab384108542847d37f9278e66dd0e

exports.FETCH_AUTHORS_ENDPOINT = FETCH_AUTHORS_ENDPOINT;
var MAX_FILE_SIZE = '20971520'; // 10MB

exports.MAX_FILE_SIZE = MAX_FILE_SIZE;
var MAX_AMOUNT_OF_FILES_UPLOADED_AT_ONCE = 10;
exports.MAX_AMOUNT_OF_FILES_UPLOADED_AT_ONCE = MAX_AMOUNT_OF_FILES_UPLOADED_AT_ONCE;
var EXT_ALLOWED = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
exports.EXT_ALLOWED = EXT_ALLOWED;
var MAX_THUMBNAIL_WIDTH = 750;
exports.MAX_THUMBNAIL_WIDTH = MAX_THUMBNAIL_WIDTH;
var FILE_EXT_MAPPING = {
  'image/png': 'png',
  'image/gif': 'gif',
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/svg+xml': 'svg'
}; // We use this to return different sizes from Free Images and My Images

exports.FILE_EXT_MAPPING = FILE_EXT_MAPPING;
var SIZES = [4020, 2000, 1080, 400, 150];
exports.SIZES = SIZES;
var ACCOUNTS_ALLOWED = ['facebook'];
exports.ACCOUNTS_ALLOWED = ACCOUNTS_ALLOWED;
var supportedProducts = ['controlpanel', 'expresseditor', 'appmarket', 'store']; // ERROR constants

exports.supportedProducts = supportedProducts;
var MAX_FILE = 'MAX_FILE_SIZE_EXCEEDED';
exports.MAX_FILE = MAX_FILE;
var EXT_NOT_ALLOWED = 'EXTENSION_NOT_ALLOWED';
exports.EXT_NOT_ALLOWED = EXT_NOT_ALLOWED;
var NOT_A_FILE = 'NOT_A_FILE';
exports.NOT_A_FILE = NOT_A_FILE;
var TOO_MANY_FILES = 'TOO_MANY_FILES'; // These are keys currently supported, they resolve to keys from our runtime config

exports.TOO_MANY_FILES = TOO_MANY_FILES;
var productToSettingsKey = {
  store: 'store-editor-api',
  expresseditor: 're_api',
  appmarket: 'app_market_api',
  controlpanel: 'api'
};
var productToSettingsKeyGateway = {
  store: 'store-edit',
  expresseditor: 'express-editor',
  controlpanel: 'control-panel'
}; // We do a quick "map to key" for our token urls from the runtimeConfig.

var tokenUrls = function tokenUrls(product) {
  if (product === 'expresseditor') {
    return (0, _urlHelper.api)('', 'express-editor').slice(0, -1);
  }

  var runtimeConfig = (0, _runtimeConfigHelper.getRuntimeConfig)();
  var useAppGateway = runtimeConfig._enableAppGateway || false;
  var productKeyGateway = productToSettingsKeyGateway[product];

  if (useAppGateway && productKeyGateway) {
    return (0, _urlHelper.api)('', productKeyGateway).slice(0, -1);
  }

  var productKey = productToSettingsKey[product || 'expresseditor'];
  return (0, _urlHelper.getBaseUrl)(productKey);
};

exports.tokenUrls = tokenUrls;